/**
 * Centralized navigation configuration
 * Used by all navigation components to maintain single source of truth
 */

// Common support links for both logged-in and logged-out users
export const supportLinks = [
  { to: "/clinic-policy", label: "Clinic Policies" },
  { to: "/faq", label: "FAQ" },
  { to: "/about", label: "About us" },
  { to: "/contact", label: "Contact us" }
];

// Common service links for both logged-in and logged-out users
export const serviceLinks = [
  { to: "/medicalform", label: "Medical Forms" },
  { to: "/book-appointment", label: "Book Appointments" },
  { to: "/immi", label: "Immigration Medical Exam" }
];

// Service links for logged-out users (redirect to login)
export const loggedOutServiceLinks = [
  ...serviceLinks,
  
  { to: "/login", label: "AskMedication ™" },
  { to: "/login", label: "Lab Testing" },
  { to: "/login", label: "Radiology Testing" },
  { to: "/sicknote", label: "Sick Notes" },
];

// Service links for logged-in users (direct access)
export const loggedInServiceLinks = [
  ...serviceLinks,
  { to: "/dashboard", label: "AskMedication ™" },
  { to: "/dashboard", label: "Lab Testing " },
  { to: "/dashboard", label: "Radiology Testing " },
  { to: "/sicknote", label: "Sick Notes" }
];

// Links available only to logged-in users
export const loggedInOnlyLinks = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/account", label: "My Account" },
  { to: "/appointments/me", label: "My appointments" },
  { to: "/message", label: "My Messages" }
];

// Links available only to logged-out users
// export const loggedOutOnlyLinks = [
//   { to: "/login", label: "Login" },
//   { to: "/register", label: "Register" }
// ];